module.exports = __webpack_public_path__ + "h5/img/promotion_title.76ebd01c.png";